import Indice from "./Indice";
export default Indice;